module.exports = __webpack_public_path__ + "static/media/keppSimple.f409686e.jpeg";